// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Regex from "../utils/Regex.bs.js";

var firstNameInput = {
  required: {
    value: true,
    message: "First name is required"
  },
  pattern: {
    value: Regex.notOnlySpaceRegex,
    message: "Please enter a valid name"
  }
};

var lastNameInput = {
  required: {
    value: true,
    message: "Last name is required"
  },
  pattern: {
    value: Regex.notOnlySpaceRegex,
    message: "Please enter a valid name"
  }
};

var emailInput = {
  required: {
    value: true,
    message: "Your email is required"
  },
  pattern: {
    value: Regex.emailRegex,
    message: "Please enter a valid email address"
  }
};

var passwordInput = {
  required: {
    value: true,
    message: "Password is required"
  },
  pattern: {
    value: Regex.passwordRegex,
    message: "Please retry with a more secure password. (Max: 100 Characters)"
  }
};

var prezzeeTnCInput = {
  required: {
    value: true,
    message: "Please accept terms and conditions"
  }
};

var nzTnCInput = {
  required: {
    value: true,
    message: "Please make sure you have accepted the terms"
  }
};

var marketingOptInInput = {};

export {
  firstNameInput ,
  lastNameInput ,
  emailInput ,
  passwordInput ,
  prezzeeTnCInput ,
  nzTnCInput ,
  marketingOptInInput ,
}
/* No side effect */
